import React from "react";
import Grid from '@mui/material/Grid2';
import {
    Box,
} from '@mui/material';
import './Breadcrumbs.css'


const Breadcrumbs = () => (
    <Box component="section" className="breadCrumbBox">
        <Grid container className="container" style={{padding:'16px'}}>
            <Grid item size={12} ></Grid>
        </Grid>
    </Box>
);

export default Breadcrumbs;